export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}skill/skill/:id`;

    return $resource(url, { id: '@id' }, {
        query: { method: 'GET', url, isArray: true },
        get: { method: 'GET', url },
        save: { method: 'POST', url },
        update: { method: 'PUT', url },
        activation: { method: 'PUT', url: `${SEED_CORE.ENV.API_URL}skill/skill/:id/activation` },
        affectedApgs: { method: 'GET', url: `${SEED_CORE.ENV.API_URL}skill/skill/:id/affected-apgs` },
        delete: { method: 'DELETE', url },
        users: { method: 'POST', url: `${url}/skill-users`, isArray: true }
    });
};




// WEBPACK FOOTER //
// ./src/app/resources/Skill/index.js